/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import { useBrowserLayout } from "@src/utils/hooks/layout"
import ApplyContent from "@src/components/applyModal/ApplyContent"
import { wxConfig, wxShare } from "@src/utils/wechat"
import Switch from "gpages/components/switch"
import { navigate } from "gatsby"
import config from "@config"

const LANG_OPTIONS = [
  {
    label: "中",
    value: "zh",
  },
  {
    label: "ENG",
    value: "en",
  },
]

const Layout = ({
  children,
  location,
  pageContext: { lang = "zh", langData = {} },
}) => {
  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  const { isAppLayout } = useBrowserLayout()
  // 可根据需要在 onChange 里切换语言逻辑
  return (
    <AppContext.Provider value={{ isAppLayout, lang, langData }}>
      <Seo
        lang={lang}
        title={langData.page_title}
        description={langData.page_desc}
        titleTemplate={undefined}
      />
      <Nav location={location} />

      <main className={styles.container}>
        <div className={styles.langSitchContainer}>
          <Switch
            className={styles.langSwitch}
            options={LANG_OPTIONS}
            value={lang}
            location={location}
            appName={config.appKey}
            onChange={(v, pathname) => {
              navigate(pathname)
            }}
          />
        </div>
        {children}
      </main>
      {isAppLayout && (
        <footer className={styles.footer}>
          <ApplyContent />
        </footer>
      )}
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
